import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "../Context.js";
import { sortFn } from "../Utils.js";
import { map, getSubArray } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { onPageChange, headerSortCell } from "../ViewHelpers.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { TableContainer, TableFooter, TablePagination, Link, TableBody, TableRow, TableHead, Table, Typography, TableCell } from "@mui/material";
import { int32ToString, createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import Info from "@mui/icons-material/Info";
import { singleton, ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { RouterModule_encodeParts } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { Tickets_TicketStatus_FromId_Z524259A4 } from "../Shared/Shared.js";
import { Tickets_StatusChip_Z17F2D702 } from "./Tickets/StatusChip.js";

export function Components_CriticalTicketsTable_334C27A3(components_CriticalTicketsTable_334C27A3InputProps) {
    let elems_1, elems, props_5, children_3, elements_6, elements_1, elements, elements_3, children_2, children_1, values;
    const tickets = components_CriticalTicketsTable_334C27A3InputProps.tickets;
    const patternInput = reactApi.useState(true);
    const setAsc = patternInput[1];
    const asc = patternInput[0];
    const patternInput_1 = reactApi.useState("Id");
    const sortKey = patternInput_1[0];
    const ctx = reactApi.useContext(ctx_1);
    const patternInput_2 = reactApi.useState(0);
    const setPage = patternInput_2[1];
    const page = patternInput_2[0] | 0;
    const patternInput_3 = reactApi.useState(5);
    const rowsPerPage = patternInput_3[0] | 0;
    const rowsToSkip = (page * rowsPerPage) | 0;
    let rowsToTake;
    const nextTakeCount = (rowsToSkip + rowsPerPage) | 0;
    rowsToTake = ((tickets.length < nextTakeCount) ? (tickets.length - rowsToSkip) : rowsPerPage);
    const sorted = sortFn(asc, sortKey)(tickets);
    const currentRows = getSubArray(sorted, rowsToSkip, rowsToTake);
    const th = (key_1, label) => headerSortCell(sortKey, asc, (key) => {
        if (sortKey === key) {
            setAsc(!asc);
        }
        else {
            setAsc(true);
            patternInput_1[1](key);
        }
    }, key_1, label);
    const cell = (child) => MuiHelpers_createElement(TableCell, [["children", child]]);
    const xs_5 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 10 + "px",
    }], (elems_1 = [MuiHelpers_createElement(Typography, [["variant", "h4"], ["children", ctx.Locale.t("Dashboard.CriticalTickets")]]), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        gap: 10 + "px",
    }], (elems = [(props_5 = {}, react.createElement(Info, props_5)), MuiHelpers_createElement(Typography, [["children", ctx.Locale.t("Dashboard.TicketTab")]])], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), (children_3 = singleton(MuiHelpers_createElement(Table, [(elements_6 = [MuiHelpers_createElement(TableHead, [(elements_1 = [MuiHelpers_createElement(TableRow, [(elements = [th("Customer", ctx.Locale.t("Customer.Customer")), th("Status", ctx.Locale.t("Ticket.Status.Status")), th("Id", "#"), th("Desc", ctx.Locale.t("SparePart.Description"))], ["children", reactApi.Children.toArray(Array.from(elements))])])], ["children", reactApi.Children.toArray(Array.from(elements_1))])]), MuiHelpers_createElement(TableBody, [(elements_3 = map((ticket) => {
        let elements_2, width, text;
        const ticketUrl = RouterModule_encodeParts(ofArray(["tickets", int32ToString(ticket.Id)]), 1);
        let statusChip;
        const status = Tickets_TicketStatus_FromId_Z524259A4(ticket.Status);
        statusChip = createElement(Tickets_StatusChip_Z17F2D702, {
            status: status,
            readOnly: true,
        });
        return MuiHelpers_createElement(TableRow, [(elements_2 = [cell(MuiHelpers_createElement(Typography, [["variant", "body2"], ["sx", {
            maxWidth: 30 + "ch",
        }], ["noWrap", true], ["children", ticket.Customer.Name]])), cell(createElement("div", {
            style: {
                display: "flex",
            },
            children: statusChip,
        })), cell(MuiHelpers_createElement(Link, [["href", ticketUrl], ["children", `#${ticket.Id}`]])), (width = (50 + "ch"), (text = ticket.ShortDesc, MuiHelpers_createElement(TableCell, [["title", text], ["sx", {
            minWidth: width,
            maxWidth: width,
        }], ["variant", "body"], ["children", MuiHelpers_createElement(Typography, [["variant", "body2"], ["noWrap", true], ["children", text]])]])))], ["children", reactApi.Children.toArray(Array.from(elements_2))])]);
    }, currentRows), ["children", reactApi.Children.toArray(Array.from(elements_3))])]), (children_2 = singleton((children_1 = singleton(MuiHelpers_createElement(TablePagination, [["count", sorted.length], ["page", page], ["rowsPerPage", rowsPerPage], (values = (new Int32Array([5, 10, 20])), ["rowsPerPageOptions", Array.from(values)]), ["onPageChange", ((arg10$0040, newPage) => {
        onPageChange(setPage, arg10$0040, newPage);
    })], ["onRowsPerPageChange", (ev) => {
        const newRowsPerPage = ev.target.value | 0;
        setPage(0);
        patternInput_3[1](newRowsPerPage);
    }]])), MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(children_1))]]))), MuiHelpers_createElement(TableFooter, [["children", reactApi.Children.toArray(Array.from(children_2))]]))], ["children", reactApi.Children.toArray(Array.from(elements_6))])])), MuiHelpers_createElement(TableContainer, [["children", reactApi.Children.toArray(Array.from(children_3))]]))];
    return react.createElement(react.Fragment, {}, ...xs_5);
}

